import axios from "axios";

import type { NotificationResponse, ParamsNotificationObject } from "../shared/interface/Notification/index.interface";
import { DataToSendObject } from "../shared/interface/notification.interface";

export const getAllMaintenanceNotification = async (params: ParamsNotificationObject) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/notification?page=${params.page}&pageSize=${params.pageSize}`;

    if (params.customerId) {
      query += `&customerId=${params.customerId}`;
    }

    if (params.locationId) {
      query += `&locationId=${params.locationId}`;
    }

    if (params.fromDate) {
      query += `&fromDate=${params.fromDate}`;
    }

    if (params.toDate) {
      query += `&toDate=${params.toDate}`;
    }

    const res = await axios.get(query);

    return res.data as NotificationResponse;
  } catch (error) {
    throw error;
  }
};

export const createMaintenanceNotification = async (formData: DataToSendObject) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/notification`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
